/**
 * Ask Yelo: a car's number -> the contract it is on NOW, first and clearly (owner, 12 Oct 2026: "لو كتبت رقم عربية اول
 * حاجه تظهر العقد المرفوعه عليه بشكل واضح"). Pure: the records come from the contracts store's search.
 */
import { dubaiText } from './contractsV2';

// a car's number as typed: "74681", "CC 74681", "cc74681", "O 22407" - an emirate code of 1-2 letters, 1-5 digits
const PLATE_RE = /^([a-z]{1,2})?\s*-?\s*(\d{1,5})$/i;

/** { code, number } of a typed car number, or null. Digits alone need 3 at least (a "12" is not a car). */
export function plateOf(text) {
    const m = String(text || '').trim().match(PLATE_RE);
    if (!m) return null;
    const code = (m[1] || '').toUpperCase();
    if (!code && m[2].length < 3) return null;
    return { code, number: String(Number(m[2])) };
}

const splitPlate = (plate) => {
    const m = String(plate || '').toUpperCase().replace(/\s+/g, ' ').trim().match(/^([A-Z]{1,2})?\s*(\d{1,5})$/);
    return m ? { code: m[1] || '', number: String(Number(m[2])), text: `${m[1] ? `${m[1]} ` : ''}${Number(m[2])}` } : null;
};
const isOpen = (v) => String(v?.status || '').trim().toLowerCase() === 'open';
const at = (v, key) => String(v?.[key] || '');

/**
 * Each car the typed number names (CC 74681 and O 74681 are two cars), newest contract first:
 * [{ plate, open: record|null, last: record|null }] - ``open`` = the contract the car is on now (its CURRENT car,
 * after any swap), ``last`` = its newest contract when none is open. Records are the store's (car.plate = the car now).
 */
export function carContracts(typed, records) {
    const want = plateOf(typed);
    if (!want) return [];
    const cars = new Map();
    for (const v of records || []) {
        const p = splitPlate(v?.car?.plate);
        if (!p || p.number !== want.number || (want.code && p.code !== want.code)) continue;
        if (!cars.has(p.text)) cars.set(p.text, []);
        cars.get(p.text).push(v);
    }
    return [...cars.entries()].map(([plate, list]) => {
        const sorted = [...list].sort((a, b) => at(b, 'pickup_date').localeCompare(at(a, 'pickup_date')));
        const open = sorted.find(isOpen) || null;
        return { plate, open, last: open ? null : sorted[0] || null };
    }).sort((a, b) => (b.open ? 1 : 0) - (a.open ? 1 : 0) || a.plate.localeCompare(b.plate));
}

/** What the card shows of one contract record. */
export function contractCard(v) {
    if (!v) return null;
    const no = String(v.contract_no || '').trim().toUpperCase();
    return {
        no,
        status: String(v.status || '').trim(),
        customer: String(v.customer?.name || '').trim(),
        phone: String(v.customer?.phone || '').trim(),
        identity: String(v.customer?.identity || '').trim(),
        branch: String(v.branch || v.ejar_branch_name || '').trim(),
        from: dubaiText(v.pickup_date),
        to: dubaiText(v.dropoff_date),
        airport: /airport|terminal/i.test(String(v.branch || v.ejar_branch_name || '')),
    };
}
